export default [
  // 活动详情
  {
    path: 'loading',
    component: () => import('@/views/modules/demo/loading'),
    name: 'loading',
    meta: { title: '请求按钮', needToken: false }
  }
]
